<template>
    <div
        :class="[
            'c-list-shop__info--like',
            { active: isActive },
        ]"
        v-on:click="toggleFavorite"
        >
        <img
            src="/assets/images/icon/icon-heart-white.svg"
            width="12"
            height="12"
            alt=""
        />
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "FavoriteIcon",
    props: {
        isActive: {
            type: Boolean,
            default: false,
        },
        toggleFavorite: {
            type: Function,
            required: true,
        },
    },
});

</script>